import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import * as React from "react";
import { useLanguage } from "../../Language";
import { useDisplayMapItButton, useStackMap } from "../../Stackmap";
import { StackMapButton } from "./StackMapButton";
import {
  HoldingsInformation,
  ResourceDWR,
} from "../../../dto/SuggestionResult";
import { useItemAvailability } from "./ItemAvailability";

export interface SerialHoldingsProps {
  holdings: HoldingsInformation[];
  resource: ResourceDWR;
}
export const SerialHoldings: React.FC<SerialHoldingsProps> = ({
  holdings,
  resource,
}) => {
  const { translate } = useLanguage();
  const { openMapItDialog, stackMapEnabled } = useStackMap();
  const { itemAvailability, ready } = useItemAvailability(holdings, resource);
  const displayMapItButton = useDisplayMapItButton(
    holdings,
    itemAvailability,
    ready,
    resource
  );

  return (
    <Table component="table">
      <TableHead component="thead">
        <TableRow component="tr">
          <TableCell component="th">{translate("collection")}</TableCell>
          <TableCell component="th">{translate("serialInfo")}</TableCell>
          <TableCell component="th">{translate("status")}</TableCell>
          <TableCell component="th">
            {stackMapEnabled ? translate("stackMapColumnHeader") : ""}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody component="tbody">
        {holdings
          .sort((lhs, rhs) => {
            const leftSort = lhs.chronologySort + lhs.enumerationSort;
            const rightSort = rhs.chronologySort + rhs.enumerationSort;
            if (leftSort < rightSort) {
              return 1;
            } else if (leftSort > rightSort) {
              return -1;
            }
            return 0;
          })
          .map((holding) => {
            const availability = itemAvailability.get(holding.barcode);
            return (
              <TableRow component="tr" key={holding.id}>
                <TableCell component="td" scope="row">
                  {holding.collectionName}
                </TableCell>
                <TableCell component="td">
                  {" "}
                  {holding.chronology} <br /> {holding.enumeration}
                </TableCell>
                <TableCell component="td">{availability?.status}</TableCell>
                <TableCell component="td" sx={{ textAlign: "center" }}>
                  {displayMapItButton.get(holding.id) ? (
                    <StackMapButton
                      onClick={() => openMapItDialog(holding.id)}
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};
